import { Component, OnInit, Input } from '@angular/core';
import { AppMetadataHandler } from 'app/BaseFramework/configs/app-metadata.handler';


@Component({
  selector: 'app-label-view',
  templateUrl: './label-view.component.html',
  styleUrls: ['./label-view.component.scss']
})
export class LabelViewComponent implements OnInit {

  constructor(
    public appMetadataHandler: AppMetadataHandler,
  ) { }


  @Input() fieldType: string;
  @Input() fieldName: string;
  @Input() fieldValue: string;
  @Input() dummyValue: string;
  @Input() dummyValueFlag: boolean;


  ngOnInit() {
  }

}
